import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PortfolioListRecordModel } from '@admin/portfolios/shared/models/portfolio-list-record-model';
import { PortfolioService } from '@admin/portfolios/shared/services/portfolio.service';
import { PortfolioCustomerDetailsModel } from '@admin/portfolios/shared/models/portfolio-customer-details-model';
import { CustomMessageService } from '@admin/core/message.service';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-portfolio-customer-move',
  templateUrl: './portfolio-customer-move.component.html',
  styleUrls: ['./portfolio-customer-move.component.less'],
  standalone: false,
})
export class PortfolioCustomerMoveComponent implements OnInit {
  @Input()
  public display: boolean;

  @Input()
  public customers: PortfolioCustomerDetailsModel[];

  @Input()
  public currentPortfolioId: number;

  public portfolios: PortfolioListRecordModel[];
  public selectedPortfolio: number;

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  onSave() {
    if (this.customers.length > 0 && this.selectedPortfolio != null) {
      this.portfolioService
        .moveCustomerToPortfolio(
          this.currentPortfolioId,
          this.selectedPortfolio,
          this.customers
        )
        .subscribe(() => {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translationService.instant('message.SaveMessage'),
          });
        });
      this.onUpdate.emit(true);
    }
  }

  onCancel() {
    this.onUpdate.emit(false);
  }

  constructor(
    private portfolioService: PortfolioService,
    private translationService: TranslateService,
    private messageService: CustomMessageService
  ) {
    this.portfolioService.listPortfolios().subscribe((p) => {
      this.portfolios = p.items.filter(
        (p) => p.portfolio.portfolioId != this.currentPortfolioId
      );
      this.selectedPortfolio = null;
    });
  }

  ngOnInit() {}
}
